// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Loading from 'react-loading';
import Modal from './Modal';
import api from '../../api';

export default class PretrainedModel extends Modal {

    state = {
        groups: [],
        loading: false
    }

    componentDidMount = async () => {
        await this.setState({ loading: true });
        const res = await api.get('/stack/base');
        if (res && res.groups)
            await this.setState({ groups: res.groups });
        this.setState({ loading: false });
    }

    renderContent = () => {
        return (<div className="modal-content modal-center">
            
            <h1>Pick a pre-trained model</h1>

            <p>
                Pick a pretrained model from our available list of base stacks. Your new stack will sort documents based on this model, but will start learning the specifics of <strong>your</strong> documents after it starts seeing some.
            </p>

            <div style={{ height: 20 }} />

            {this.state.loading ? <div style={{
                width: 100,
                margin: '0 auto',
                marginTop: 40
            }}><Loading
                type="bubbles"
                color="var(--color-primary)"
                height={100}
                width={100}
            /></div> : <div className="modal-pretrained-container">
                {this.state.groups.map((g,idx) => <div
                    className="modal-pretrained-group"
                    key={idx}
                    style={{ backgroundImage: "url('https://static.stax.ai/images/base/" + g.group + ".png')" }}
                >
                    <div className="modal-pretrained-meta">{g.group}</div>
                    <>
                        {g.stacks.map((s,jdx) => {
                            if (this.props.stacks.find(a => a.path === s.name))
                                return null;

                            return (<div
                                key={jdx}
                                className="modal-pretrained-stack"
                                title={"Click to create a new stack"}
                                onClick={() => {
                                    this.props.modal();
                                    this.props.createStackExec(this.props.data.name ? this.props.data.name : s.name, this.props.data.root, s._id);
                                }}
                            >{s.name}</div>)
                        })}
                    </>
                    <div style={{ clear: 'both' }} />
                </div>)}
            </div>}

        </div>);
    }

};